/*
 PanelRight

 Lewy panel - pobranie z bazy przez API
 Uwaga! Było w lewym panelu. Rekompozycja związana z opcją na komórki. 

 */
import * as React from 'react';

import { connect } from 'react-redux';

import { AppState, IPageState } from '../../appredux';
/*
import BusinessCard from '../components/BusinessCard';
<BusinessCard />
*/

import { withStyles, WithStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { Button, Paper } from '@material-ui/core';
import CustomPanel from './PanelRightCustom';
import Contact from './Contact';
import ZarzadzajRezerwacja from '../manageReservation/ZarzadzajRezerwacja';
import { Trans } from 'react-i18next';

import './PanelRight.css';

import CONFIG from '../../cfg/config';

import { Info } from '../../api';
import PolicyIcon from '@mui/icons-material/Policy';

import platnosciLogo from 'app/assets/Przelewy24_logo.png'
import mbankLogo from 'app/assets/mbank.png'
import autopayLogo from 'app/assets/logo_autopay.png'
import payuLogo from 'app/assets/logo_payu.png'

import QRCode from 'qrcode.react';
import { downloadQR } from 'app/common/helpers';

import { QRCode as QR} from 'react-qrcode-logo';
import DialogQR from './DialogQR';

//const logo =  './img/'+CONFIG.hotelID+'/logo.png' ;
//let logoUrl : string = `${CONFIG.apiURL}/hotel/img/${CONFIG.hotelID}/logo.png`
//PM 2021-11-08
//wstrzykniecie tylko uzywanych pol z magazynu danych

const CustomTheme = createTheme({
  palette: {
    primary: {
      main: "rgb(0, 128, 128)",
    },
  },
});

interface PanelRightProps extends WithStyles<typeof styles> {
  
  notifierOpen: number,
  contact: Info,
  page: IPageState,

  setZarzadzajOpen: () => void
}

interface PanelRightState {
  
  openQr: boolean;
  
}

class PanelRight extends React.Component<PanelRightProps, PanelRightState>  {

  constructor(props: PanelRightProps) {
    super(props, {});


    this.state = {
      openQr: false,
    }
  }

  logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/startowe.jpg`;
  logoIkonaUrl: string | any = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/startowe_ikona.jpg`;

  //PM 2021-11-08
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  componentDidMount() {
    //this.logoIkonaUrl = this.imageCheck(this.logoIkonaUrl, require('../assets/icon.png').default)
    this.imageCheck(this.logoIkonaUrl, require('../assets/icon.png').default)
  }

  imageCheck = (url: string, fallback: any) => {
    const img = new Image();
    img.src = url;

    if (img.complete) {
      //ok
      return url
    } else {
      img.onload = () => {
        //ok
        return url
      };

      img.onerror = () => {
        //error
        this.logoIkonaUrl  = require('../assets/icon.png').default
        return fallback
      };
    }
  }

  //PM 2021-11-08
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  componentDidUpdate(prevProps: PanelRightProps) {
    
  }

  setOpenQr = () => {
    this.setState({ openQr: true });
  }

  setCloseQr = () => {
    this.setState({ openQr: false });
  }

  qrCodeValue = () => {
    let value = ''
    value = value + `https://vsc24.net/vscHotelBook/hotel/${CONFIG.hotelID}`
    return value
}

isValidHexaCode = (str: string) => {
  if (str[0] != '#')
      return false;

  if (!(str.length == 4 || str.length == 7))
      return false;

  for (let i = 1; i < str.length; i++)
  if (!((str[i] >= '0' && str[i] <= '9')
      || (str[i] >= 'a' && str[i] <= 'f')
      || (str[i] >= 'A' || str[i] <= 'F')))
      return false;

  return true;
}

  //PM 2021-11-08
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render = () => {
    const { classes } = this.props;
    //console.log(this.state)

    let linkMbank = "https://pdf.mbank.pl/mbankpl/of/regulaminy/uslugi/regulamin_uslug_platniczych_dla_osob_fizycznych_i_klientow_private_banking_w_ramach_bankowosci_detalicznej_mbanku_s.a._od_13.09.2023_r.pdf"
    let linkAutopay = "https://mobility.autopay.pl/storage/pdf/regulamin-autopay_15_01_2025.pdf"
    let linkPayu = "https://poland.payu.com/wp-content/uploads/sites/14/2022/01/REGULAMIN_USLUGI_PLATNOSCI_ELEKTRONICZNYCH_oct20_1.pdf"


    let zasady4Link = `https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady4Link}`
    if(CONFIG.zasady4Link.includes(".pdf")){
      zasady4Link = `https://vsc24.net/vscHotelBook/hotel/pdf/${CONFIG.hotelID}/${CONFIG.zasady4Link}`
      //https://vsc24.net/vscHotelBook/hotel/pdf/zielona-gora-PCK/wniosek-o-zwrot-wplaty-za-nocleg.pdf
    }

    const data = {
      title: "kontakt z nami",
      email: this.props.contact.kontaktEmail,
      phone: this.props.contact.kontaktTelefon,
      gps: this.props.contact.kontaktGps,
      address: this.props.contact.kontaktAdres,
      adressMap: this.props.page.contact.googleMaps
    };

    let info = this.props.page.contact.info
        let index = info.search("olor=")
        let color = "#5F9EA0"

        if(index > 0){
            let c = info.substring(index + 5, index + 5 + 7)
            if(this.isValidHexaCode(c)){
                color = c
            }  
        }

    return (
      <div>
        {/* <GoogleIcons /> */}
        {/* <ContactPanel /> */}
        <Paper elevation={0} className={classes.paper}  > {/*elevation={4}*/}
          <Contact data={data} titleSize="16px" fontSize="11px" iconSize="15px" onSzukaj={this.props.setZarzadzajOpen} /*googleIcons*/ logoUrl={this.logoUrl} color={color} />
        </Paper>
        <CustomPanel />
        {/* <div style={{
          textAlign: 'center', marginBottom: "1px", padding: "0px",
          paddingLeft: "14px", paddingTop: "5px"
        }}>

          <ResponsiveImgMaterialUi style={{ height: "50%", width: "50%" }}
            xs={this.logoUrl}
            md={this.logoUrl}
            lg={this.logoUrl}
          />
        </div> */}

        {/* <div id="footer">
          <div className={"copyrights"} style={{
            fontSize: "11px",
            fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
            lineHeight: "20px", paddingBottom: "10px",
            fontWeight: 400, textAlign: "center"
          }}>
            <a className={classes.link}
              href="http://www.virtualsc.com.pl">copyright © VIRTUAL sc, www.virtualsc.com.pl</a><br />
          </div>  
        </div>*/}
        {/*tel.(17) 85 070 85*/}

        {/* {this.props.contact.payWeb !== "0" ?
          <div style={{
            textAlign: 'center', marginBottom: "1px",
            padding: "5px 20px 0px"
          }}> */}

            {/* {this.props.contact.payWeb === "1" ?
              <a href={`https://vsc24.net/vscZasady/zasady/CashBill/${CONFIG.hotelID}`} rel="noreferrer" target="_blank">
                <img alt="Płatności CashBill" src="https://img.cashbill.pl/cb/logo/00-logotypy/c-cashbill_100x39_b.png" width="100" height="39" />
              </a>
              : this.props.contact.payWeb === "4" ?
                <a href={`https://vsc24.net/vscZasady/zasady/Przelewy24/${CONFIG.hotelID}`} target="_blank" rel="noreferrer">
                  <img src={platnosciLogo} style={{ maxWidth: '70px' }} alt="Płatności Przelewy24" />
                </a>
                : this.props.contact.payWeb === "5" ?
                  <a
                    href={`https://vsc24.net/vscZasady/zasady/TPay/${CONFIG.hotelID}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="https://tpay.com/img/banners/tpay_zaufane_platnosci.svg" style={{ border: 0, maxWidth: '110px' }} alt="Logo Tpay" title="Logo Tpay" />
                  </a>
                  : null} */}
            {/* <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.hotelID}`} target="_blank" rel="noreferrer" className={`${classes.link} ${classes.alignCenter}`}>
              <Button
                variant="text"
                color="inherit"
                startIcon={<PolicyIcon />}
                className={classes.linkButton}
              >
                regulamin
              </Button>
            </a>

          </div>
          : null} */}

        <ThemeProvider theme={createTheme({
          palette: {
            primary: {
              main: `${color}`,
            },
          },
        })}>          

        {CONFIG.zasady1 === "1" ?        
          <div  style={{ textAlign: 'center', padding: "4px 20px"}}>
            <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady1Link}`} className={classes.link1} target="_blank" rel="noreferrer">
            <Button variant="outlined" size="medium" color="primary" className={`${classes.button}`}>
                {CONFIG.zasady1Opis}
              </Button>
            </a>     
          </div>
        : null}  

        {CONFIG.zasady2 === "1" ?    
          <div  style={{ textAlign: 'center', padding: "4px 20px"}}>
            <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady2Link}`} className={classes.link1}  target="_blank" rel="noreferrer">
              <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}>
                {CONFIG.zasady2Opis}
              </Button>    
            </a>
          </div>
          : null}   

          {CONFIG.zasady3 === "1" ?
            <div style={{ textAlign: 'center', padding: "4px 20px" }}>
              <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.zasady3Link}`} className={classes.link1} target="_blank" rel="noreferrer">
                <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}>
                  {CONFIG.zasady3Opis}
                </Button>
              </a>
            </div>
            : null}     
            
            {CONFIG.zasady4 === "1" ?
            <div style={{ textAlign: 'center', padding: "4px 20px" }}>
              <a href={zasady4Link} className={classes.link1} target="_blank" rel="noreferrer">
                <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}>
                  {CONFIG.zasady4Opis}
                </Button>
              </a>
            </div>
            : null}   

        </ThemeProvider> 

        {CONFIG.ikonaPrzelewy24 === "1" ?
          <div style={{ textAlign: 'center', marginBottom: "1px", padding: "15px 20px 10px"}}>
            <a className={classes.alignCenter} href={`https://vsc24.net/vscZasady/zasady/Przelewy24/${CONFIG.hotelID}`} target="_blank" rel="noreferrer">
              {/* require('./Przelewy24_logo.png').default */}
              <img src={platnosciLogo} className={`${classes.imgP24} `} alt="Płatności Przelewy24" />
            </a>
          </div>
          : null}

        {CONFIG.ikonaMBank === "1" ?
          <div style={{ textAlign: 'center', marginBottom: "1px", padding: "15px 20px 10px"}}>
            <a className={classes.alignCenter} href={linkMbank} target="_blank" rel="noreferrer">
              {/* require('./Przelewy24_logo.png').default */}
              <img src={mbankLogo} className={`${classes.imgP24} `} alt="Płatności Mbank" />
            </a>
          </div>
          : null}
          
          {CONFIG.ikonaAutoPay === "1" ?
          <div style={{ textAlign: 'center', marginBottom: "1px", padding: "15px 20px 10px"}}>
            <a className={classes.alignCenter} href={linkAutopay} target="_blank" rel="noreferrer">
              {/* require('./Przelewy24_logo.png').default */}
              <img src={autopayLogo} className={`${classes.imgP24} `} alt="Płatności Autopay" />
            </a>
          </div>
          : null}
          
          {CONFIG.ikonaPayU === "1" ?
          <div style={{ textAlign: 'center', marginBottom: "1px", padding: "15px 20px 10px"}}>
            <a className={classes.alignCenter} href={linkPayu} target="_blank" rel="noreferrer">
              {/* require('./Przelewy24_logo.png').default */}
              <img src={payuLogo} className={`${classes.imgP24} `} alt="Płatności PayU" />
            </a>
          </div>
          : null}



        {/* size={256} */}
        {/* <div className={classes.qr}> */}
          {/* <QRCode id="qrCodeVisible" value={this.qrCodeValue()} size={100}
            onClick={() => downloadQR()}
            style={{ cursor: "pointer" }}
          />
          <QRCode id="qrCodeMain" value={this.qrCodeValue()} size={256}
            style={{ display: "none" }}
          /> */}
        {/* </div> */}

        {/* <div className={classes.qr} >
          <div  onClick={() => downloadQR()} style={{ cursor: "pointer" }}>
            <QR id="qrCodeMain" value={this.qrCodeValue()} size={150} logoWidth={30} logoHeight={30} removeQrCodeBehindLogo qrStyle="dots"
              //logoImage={require('../assets/icon.png').default} 
              logoImage={this.logoIkonaUrl} 
              />
          </div>
        </div> */}
        <ThemeProvider theme={CustomTheme}>  
        <div className={classes.qr} >
          {/* <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}
            onClick={this.setOpenQr}>
            <Trans>QR</Trans>
          </Button> */}
          <img src={require('../assets/qr-code-scan-lightgray2.png').default} style={{ border: 0, maxWidth: '50px', cursor: "pointer" }} alt="QR kod" title="QR kod" 
          onClick={this.setOpenQr}/>
        </div>
        </ThemeProvider>

        <DialogQR open={this.state.openQr} toggleDialog={this.setCloseQr} />
      </div>
    )
  }
}

const styles = (theme: Theme) => {

  return (
    {
      root: {
        paddingLeft: '15px',
        paddingRight: '15px',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.fontSize,
      },
      paper: {
        paddingTop: 0,
        padding: "0.4em",
        //background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
        marginBottom: "1em",
        //backgroundColor : theme.palette.background.default
        //padding: "0px",    
        "@media (min-width: 600px) and (max-width: 1300px)": {
          padding: "0 0 0.4em 0",
        },
      },
      //paper: {
      //  textColor: theme.palette.text.secondary,
      //},
      list: {
        listStyleType: 'none',
      },
      widget: {
        paddingLeft: 6,
        paddingRight: 6,
      },
      icon: {
        width: '1em',
        marginRight: '0.5em'
      },
      copyrights: {

      },
      // link: {
      //   color: theme.palette.secondary.main,
      //   textDecoration: "none"
      // }
      link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere',
        color: theme.palette.error.main
      },
      link1: {
        textDecoration: 'none',
       },
      alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
      },
      linkButton: {
        //color: '#3a87ad',
        color: 'rgb(0, 128, 128)',
        "&:hover": {
            textDecoration: "underline"
        }
    },
      button: {
        //padding: 0,
        borderRadius: "0",
        borderColor: "lavender",
        fontSize: '12px',
        lineHeight: '1.5',
        letterSpacing: '0.00938em',
        textTransform: 'none' as 'none',
        minWidth: 150,
        width: "65%",

        //"&:hover": {
        //    background: 'none'
        //}
    },
    orange: {
      color: "#e65100"
    },
      imgP24:{
        maxWidth: '100px',
        cursor: "pointer",
        "@media (max-width: 599px)": {
          maxWidth: '80px', 
        }
      },
      qr: {
        //display: 'none'
        textAlign: "center" as "center",
        //marginTop: "5px"
        //marginTop: "40px",
        padding: "4px 20px"
    },

    });
}

const mapStateToProps = (state: AppState) => ({
  rezerwacjaAnuluj: state.pageState.rezerwacjaAnuluj,
  notifierOpen: state.pageState.notifierOpen,
  contact: state.pageState.contact,
  page: state.pageState
})

export default connect(mapStateToProps)(withStyles(styles)(PanelRight));